import { Link } from 'react-router-dom';
import { useState } from 'react';
import axios from 'axios';
import { 
  Phone, ArrowRight, CheckCircle, Star, MapPin, 
  Layers, Grid3X3, Hammer, Square, Scissors, Wrench,
  ClipboardCheck, Ruler, Settings, Award
} from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { Checkbox } from '../components/ui/checkbox';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Image URLs
const images = {
  heroMain: 'https://images.unsplash.com/photo-1769736438943-3c57cbd02c22?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjB2aW55bCUyMGZsb29yaW5nJTIwbW9kZXJuJTIwaG9tZSUyMGludGVyaW9yfGVufDB8fHx8MTc3Mjc5NDEzM3ww&ixlib=rb-4.1.0&q=85',
  heroSecondary: 'https://images.unsplash.com/photo-1751806524631-565725f5bb74?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjB2aW55bCUyMGZsb29yaW5nJTIwbW9kZXJuJTIwaG9tZSUyMGludGVyaW9yfGVufDB8fHx8MTc3Mjc5NDEzM3ww&ixlib=rb-4.1.0&q=85',
  hardwood: 'https://images.unsplash.com/photo-1693948568453-a3564f179a84?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxoYXJkd29vZCUyMGZsb29yJTIwaW5zdGFsbGF0aW9uJTIwcHJvZmVzc2lvbmFsJTIwd29ya2VyfGVufDB8fHx8MTc3Mjc5NDEzMnww&ixlib=rb-4.1.0&q=85',
  vinyl: 'https://images.unsplash.com/photo-1757924461488-ef9ad0670978?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjB2aW55bCUyMGZsb29yaW5nJTIwbW9kZXJuJTIwaG9tZSUyMGludGVyaW9yfGVufDB8fHx8MTc3Mjc5NDEzM3ww&ixlib=rb-4.1.0&q=85',
  tile: 'https://images.unsplash.com/photo-1762633203398-d4432b5269b1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHx0aWxlJTIwZmxvb3JpbmclMjBiYXRocm9vbSUyMGtpdGNoZW4lMjByZW5vdmF0aW9ufGVufDB8fHx8MTc3Mjc5NDEzNHww&ixlib=rb-4.1.0&q=85',
  laminate: 'https://images.unsplash.com/photo-1704167674713-649193461719?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxoYXJkd29vZCUyMGZsb29yJTIwaW5zdGFsbGF0aW9uJTIwcHJvZmVzc2lvbmFsJTIwd29ya2VyfGVufDB8fHx8MTc3Mjc5NDEzMnww&ixlib=rb-4.1.0&q=85',
  carpet: 'https://images.unsplash.com/photo-1675916008013-3002c56f8c79?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwzfHxoYXJkd29vZCUyMGZsb29yJTIwaW5zdGFsbGF0aW9uJTIwcHJvZmVzc2lvbmFsJTIwd29ya2VyfGVufDB8fHx8MTc3Mjc5NDEzMnww&ixlib=rb-4.1.0&q=85',
  repair: 'https://images.unsplash.com/photo-1588853326295-d49400a3d085?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHw0fHxoYXJkd29vZCUyMGZsb29yJTIwaW5zdGFsbGF0aW9uJTIwcHJvZmVzc2lvbmFsJTIwd29ya2VyfGVufDB8fHx8MTc3Mjc5NDEzMnww&ixlib=rb-4.1.0&q=85',
  gallery1: 'https://images.unsplash.com/photo-1769736438943-3c57cbd02c22?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjB2aW55bCUyMGZsb29yaW5nJTIwbW9kZXJuJTIwaG9tZSUyMGludGVyaW9yfGVufDB8fHx8MTc3Mjc5NDEzM3ww&ixlib=rb-4.1.0&q=85',
  gallery2: 'https://images.unsplash.com/photo-1751806524631-565725f5bb74?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjB2aW55bCUyMGZsb29yaW5nJTIwbW9kZXJuJTIwaG9tZSUyMGludGVyaW9yfGVufDB8fHx8MTc3Mjc5NDEzM3ww&ixlib=rb-4.1.0&q=85',
  gallery3: 'https://images.unsplash.com/photo-1757924461488-ef9ad0670978?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjB2aW55bCUyMGZsb29yaW5nJTIwbW9kZXJuJTIwaG9tZSUyMGludGVyaW9yfGVufDB8fHx8MTc3Mjc5NDEzM3ww&ixlib=rb-4.1.0&q=85',
  gallery4: 'https://images.unsplash.com/photo-1753826723465-d8b8bcf5a22d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjB2aW55bCUyMGZsb29yaW5nJTIwbW9kZXJuJTIwaG9tZSUyMGludGVyaW9yfGVufDB8fHx8MTc3Mjc5NDEzM3ww&ixlib=rb-4.1.0&q=85',
  gallery5: 'https://images.unsplash.com/photo-1693948568453-a3564f179a84?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxoYXJkd29vZCUyMGZsb29yJTIwaW5zdGFsbGF0aW9uJTIwcHJvZmVzc2lvbmFsJTIwd29ya2VyfGVufDB8fHx8MTc3Mjc5NDEzMnww&ixlib=rb-4.1.0&q=85',
  gallery6: 'https://images.unsplash.com/photo-1704167674713-649193461719?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxoYXJkd29vZCUyMGZsb29yJTIwaW5zdGFsbGF0aW9uJTIwcHJvZmVzc2lvbmFsJTIwd29ya2VyfGVufDB8fHx8MTc3Mjc5NDEzMnww&ixlib=rb-4.1.0&q=85',
  gallery7: 'https://images.unsplash.com/photo-1685040339272-e387e49f712b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwyfHx0aWxlJTIwZmxvb3JpbmclMjBiYXRocm9vbSUyMGtpdGNoZW4lMjByZW5vdmF0aW9ufGVufDB8fHx8MTc3Mjc5NDEzNHww&ixlib=rb-4.1.0&q=85',
  gallery8: 'https://images.unsplash.com/photo-1765556556784-7656ee0a1bd8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwzfHx0aWxlJTIwZmxvb3JpbmclMjBiYXRocm9vbSUyMGtpdGNoZW4lMjByZW5vdmF0aW9ufGVufDB8fHx8MTc3Mjc5NDEzNHww&ixlib=rb-4.1.0&q=85',
  gallery9: 'https://images.unsplash.com/photo-1762633203398-d4432b5269b1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHx0aWxlJTIwZmxvb3JpbmclMjBiYXRocm9vbSUyMGtpdGNoZW4lMjByZW5vdmF0aW9ufGVufDB8fHx8MTc3Mjc5NDEzNHww&ixlib=rb-4.1.0&q=85',
  gallery10: 'https://images.pexels.com/photos/35042495/pexels-photo-35042495.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  gallery11: 'https://images.pexels.com/photos/30705307/pexels-photo-30705307.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  gallery12: 'https://images.unsplash.com/photo-1675916008013-3002c56f8c79?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwzfHxoYXJkd29vZCUyMGZsb29yJTIwaW5zdGFsbGF0aW9uJTIwcHJvZmVzc2lvbmFsJTIwd29ya2VyfGVufDB8fHx8MTc3Mjc5NDEzMnww&ixlib=rb-4.1.0&q=85',
};

const services = [
  {
    icon: Layers,
    title: 'Hardwood Flooring Installation',
    description: 'Classic, durable hardwood floors that add timeless elegance to any space.',
    image: images.hardwood,
  },
  {
    icon: Grid3X3,
    title: 'Vinyl Flooring Installation',
    description: 'Water-resistant luxury vinyl planks perfect for any room in your home.',
    image: images.vinyl,
  },
  {
    icon: Square,
    title: 'Laminate Flooring Installation',
    description: 'Affordable, stylish laminate that mimics the look of natural materials.',
    image: images.laminate,
  },
  {
    icon: Hammer,
    title: 'Tile Flooring Installation',
    description: 'Beautiful ceramic and porcelain tiles for kitchens, bathrooms, and more.',
    image: images.tile,
  },
  {
    icon: Scissors,
    title: 'Carpet Installation',
    description: 'Soft, comfortable carpet installation for bedrooms and living spaces.',
    image: images.carpet,
  },
  {
    icon: Wrench,
    title: 'Floor Repair & Replacement',
    description: 'Expert repair services to restore your existing floors to like-new condition.',
    image: images.repair,
  },
];

const whyChooseUs = [
  { icon: Award, title: 'Experienced Flooring Installers', description: '15+ years of professional installation experience' },
  { icon: CheckCircle, title: 'High Quality Materials', description: 'Premium flooring products from trusted brands' },
  { icon: Star, title: 'Affordable Pricing', description: 'Competitive rates without compromising quality' },
  { icon: Settings, title: 'Fast Project Completion', description: 'Efficient work to minimize disruption' },
  { icon: MapPin, title: 'Residential & Commercial', description: 'Services for homes and businesses' },
  { icon: ClipboardCheck, title: 'Free Estimates', description: 'No-obligation quotes for your project' },
];

const processSteps = [
  { step: 1, icon: ClipboardCheck, title: 'Consultation', description: 'Discuss your flooring needs and preferences' },
  { step: 2, icon: Ruler, title: 'Measurement', description: 'Accurate measurements of your space' },
  { step: 3, icon: Settings, title: 'Installation', description: 'Professional installation by experts' },
  { step: 4, icon: Award, title: 'Final Inspection', description: 'Quality check and walkthrough' },
];

const testimonials = [
  {
    name: 'Jennifer Martinez',
    location: 'Los Angeles, CA',
    rating: 5,
    text: 'Buy Fusion transformed our living room with beautiful hardwood floors. The team was professional, punctual, and the quality of work exceeded our expectations. Highly recommend!',
  },
  {
    name: 'Robert Chen',
    location: 'Santa Monica, CA',
    rating: 5,
    text: 'We had vinyl flooring installed in our entire first floor. The crew was incredibly skilled and completed the job ahead of schedule. Our floors look amazing!',
  },
  {
    name: 'Sarah Thompson',
    location: 'Beverly Hills, CA',
    rating: 5,
    text: 'Outstanding service from start to finish. The tile work in our bathrooms is absolutely stunning. Professional, clean, and reasonably priced.',
  },
  {
    name: 'Michael Davis',
    location: 'Pasadena, CA',
    rating: 5,
    text: 'Best flooring company in LA! They helped us choose the perfect laminate for our rental property. Great communication and flawless installation.',
  },
];

const galleryImages = [
  { src: images.gallery1, alt: 'Modern living room with luxury flooring' },
  { src: images.gallery2, alt: 'Wood paneled media room' },
  { src: images.gallery3, alt: 'Contemporary living space' },
  { src: images.gallery4, alt: 'Stylish interior design' },
  { src: images.gallery5, alt: 'Hardwood floor close-up' },
  { src: images.gallery6, alt: 'Professional floor installation' },
  { src: images.gallery7, alt: 'Tile flooring pattern' },
  { src: images.gallery8, alt: 'White textured tiles' },
  { src: images.gallery9, alt: 'Colorful tile arrangement' },
  { src: images.gallery10, alt: 'Bathroom with checkered floor' },
  { src: images.gallery11, alt: 'Bright bathroom interior' },
  { src: images.gallery12, alt: 'Room renovation in progress' },
];

export const HomePage = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    service_type: '',
    message: '',
    consent: false,
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.phone || !formData.email || !formData.service_type) {
      toast.error('Please fill in all required fields');
      return;
    }
    setIsSubmitting(true);
    try {
      await axios.post(`${API}/contact`, formData);
      toast.success('Thank you! We will contact you shortly.');
      setFormData({ name: '', phone: '', email: '', service_type: '', message: '', consent: false });
    } catch (error) {
      toast.error('Failed to submit. Please try again.');
    }
    setIsSubmitting(false);
  };

  return (
    <main className="pt-20">
      {/* Hero Section */}
      <section className="relative min-h-[90vh] flex items-center section-stone noise-texture overflow-hidden" data-testid="hero-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24 relative z-10">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            {/* Text Content */}
            <div className="animate-slide-in-left">
              <span className="inline-block px-4 py-2 bg-amber-100 text-amber-700 rounded-full text-sm font-medium mb-6">
                Professional Flooring Services in Los Angeles
              </span>
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-amber-950 leading-tight mb-6 font-serif">
                Professional Flooring Installation Services Near You
              </h1>
              <p className="text-lg text-stone-600 mb-8 leading-relaxed">
                Transform your home or business with premium flooring solutions. From hardwood to tile, our expert installers deliver quality craftsmanship you can trust.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Link to="/contact">
                  <Button
                    className="w-full sm:w-auto bg-green-700 hover:bg-green-800 text-white rounded-full px-8 py-6 text-lg font-semibold shadow-lg hover:shadow-xl transition-all"
                    data-testid="hero-cta-estimate"
                  >
                    Get Free Estimate
                    <ArrowRight className="ml-2 w-5 h-5" />
                  </Button>
                </Link>
                <a href="tel:+18888791244">
                  <Button
                    variant="outline"
                    className="w-full sm:w-auto rounded-full px-8 py-6 text-lg font-medium border-2 border-stone-300 hover:border-amber-950 hover:bg-amber-950 hover:text-white transition-all"
                    data-testid="hero-cta-call"
                  >
                    <Phone className="mr-2 w-5 h-5" />
                    Call Now
                  </Button>
                </a>
              </div>
              <div className="mt-10 flex items-center gap-6">
                <div className="flex -space-x-3">
                  {[1, 2, 3, 4].map((i) => (
                    <div key={i} className="w-10 h-10 rounded-full bg-stone-300 border-2 border-white flex items-center justify-center text-xs font-medium text-stone-600">
                      {['JM', 'RC', 'ST', 'MD'][i - 1]}
                    </div>
                  ))}
                </div>
                <div>
                  <div className="flex items-center gap-1">
                    {[1, 2, 3, 4, 5].map((i) => (
                      <Star key={i} className="w-4 h-4 fill-amber-500 text-amber-500" />
                    ))}
                  </div>
                  <p className="text-sm text-stone-600">Trusted by 500+ homeowners</p>
                </div>
              </div>
            </div>

            {/* Image Grid */}
            <div className="relative animate-slide-in-right">
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-4">
                  <div className="img-zoom rounded-2xl overflow-hidden shadow-2xl">
                    <img
                      src={images.heroMain}
                      alt="Modern living room with luxury flooring"
                      className="w-full h-64 object-cover"
                    />
                  </div>
                  <div className="img-zoom rounded-2xl overflow-hidden shadow-lg">
                    <img
                      src={images.hardwood}
                      alt="Hardwood floor installation"
                      className="w-full h-40 object-cover"
                    />
                  </div>
                </div>
                <div className="space-y-4 pt-8">
                  <div className="img-zoom rounded-2xl overflow-hidden shadow-lg">
                    <img
                      src={images.heroSecondary}
                      alt="Wood paneled interior"
                      className="w-full h-40 object-cover"
                    />
                  </div>
                  <div className="img-zoom rounded-2xl overflow-hidden shadow-2xl">
                    <img
                      src={images.vinyl}
                      alt="Modern vinyl flooring"
                      className="w-full h-64 object-cover"
                    />
                  </div>
                </div>
              </div>
              <div className="absolute -bottom-4 -left-4 bg-white rounded-2xl p-4 shadow-xl">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                    <CheckCircle className="w-6 h-6 text-green-700" />
                  </div>
                  <div>
                    <p className="font-semibold text-amber-950">15+ Years</p>
                    <p className="text-sm text-stone-500">Experience</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-20 lg:py-28 section-white" data-testid="services-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <span className="inline-block px-4 py-2 bg-amber-100 text-amber-700 rounded-full text-sm font-medium mb-4">
              Our Services
            </span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-amber-950 font-serif mb-4">
              Expert Flooring Solutions
            </h2>
            <p className="text-lg text-stone-600 max-w-2xl mx-auto">
              From classic hardwood to modern vinyl, we offer comprehensive flooring services for every style and budget.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div
                key={index}
                className="service-card hover-lift group"
                data-testid={`service-card-${index}`}
              >
                <div className="img-zoom rounded-xl overflow-hidden mb-6">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-48 object-cover"
                  />
                </div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-12 h-12 bg-amber-100 rounded-xl flex items-center justify-center group-hover:bg-amber-600 transition-colors">
                    <service.icon className="w-6 h-6 text-amber-600 group-hover:text-white transition-colors" />
                  </div>
                  <h3 className="text-xl font-semibold text-amber-950 font-serif">{service.title}</h3>
                </div>
                <p className="text-stone-600">{service.description}</p>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <Link to="/services">
              <Button
                variant="outline"
                className="rounded-full px-8 py-6 text-lg font-medium border-2 border-stone-300 hover:border-amber-950 hover:bg-amber-950 hover:text-white transition-all"
                data-testid="view-all-services-btn"
              >
                View All Services
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="py-20 lg:py-28 section-stone noise-texture" data-testid="why-choose-us-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center mb-16">
            <span className="inline-block px-4 py-2 bg-amber-100 text-amber-700 rounded-full text-sm font-medium mb-4">
              Why Choose Us
            </span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-amber-950 font-serif mb-4">
              Trusted Flooring Experts
            </h2>
            <p className="text-lg text-stone-600 max-w-2xl mx-auto">
              We combine quality materials, skilled craftsmanship, and excellent customer service to deliver results that exceed expectations.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {whyChooseUs.map((item, index) => (
              <div
                key={index}
                className="bg-white/80 backdrop-blur-sm rounded-2xl p-8 border border-stone-100 hover:shadow-lg transition-all"
                data-testid={`why-choose-${index}`}
              >
                <div className="w-14 h-14 bg-green-100 rounded-2xl flex items-center justify-center mb-6">
                  <item.icon className="w-7 h-7 text-green-700" />
                </div>
                <h3 className="text-xl font-semibold text-amber-950 font-serif mb-3">{item.title}</h3>
                <p className="text-stone-600">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Our Process Section */}
      <section className="py-20 lg:py-28 section-white" data-testid="process-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <span className="inline-block px-4 py-2 bg-amber-100 text-amber-700 rounded-full text-sm font-medium mb-4">
              Our Process
            </span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-amber-950 font-serif mb-4">
              Simple & Efficient
            </h2>
            <p className="text-lg text-stone-600 max-w-2xl mx-auto">
              From initial consultation to final walkthrough, we make the flooring installation process seamless and stress-free.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {processSteps.map((step, index) => (
              <div
                key={index}
                className="relative text-center"
                data-testid={`process-step-${index}`}
              >
                <div className="relative inline-block mb-6">
                  <div className="w-20 h-20 bg-amber-100 rounded-full flex items-center justify-center mx-auto">
                    <step.icon className="w-10 h-10 text-amber-600" />
                  </div>
                  <span className="absolute -top-2 -right-2 w-8 h-8 bg-amber-600 text-white rounded-full flex items-center justify-center font-bold text-sm">
                    {step.step}
                  </span>
                </div>
                {index < processSteps.length - 1 && (
                  <div className="hidden lg:block absolute top-10 left-[60%] w-[80%] h-0.5 bg-gradient-to-r from-amber-300 to-stone-200"></div>
                )}
                <h3 className="text-xl font-semibold text-amber-950 font-serif mb-2">{step.title}</h3>
                <p className="text-stone-600">{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Project Gallery Section */}
      <section className="py-20 lg:py-28 section-stone noise-texture" data-testid="gallery-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center mb-16">
            <span className="inline-block px-4 py-2 bg-amber-100 text-amber-700 rounded-full text-sm font-medium mb-4">
              Project Gallery
            </span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-amber-950 font-serif mb-4">
              Our Recent Work
            </h2>
            <p className="text-lg text-stone-600 max-w-2xl mx-auto">
              Browse through our portfolio of completed flooring projects showcasing our craftsmanship and attention to detail.
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {galleryImages.map((image, index) => (
              <div
                key={index}
                className={`img-zoom rounded-2xl overflow-hidden shadow-lg ${
                  index === 0 || index === 5 ? 'md:col-span-2 md:row-span-2' : ''
                }`}
                data-testid={`gallery-image-${index}`}
              >
                <img
                  src={image.src}
                  alt={image.alt}
                  className={`w-full object-cover ${
                    index === 0 || index === 5 ? 'h-64 md:h-full' : 'h-48'
                  }`}
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-20 lg:py-28 section-white" data-testid="testimonials-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <span className="inline-block px-4 py-2 bg-amber-100 text-amber-700 rounded-full text-sm font-medium mb-4">
              Testimonials
            </span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-amber-950 font-serif mb-4">
              What Our Customers Say
            </h2>
            <p className="text-lg text-stone-600 max-w-2xl mx-auto">
              Don't just take our word for it. Hear from homeowners who trusted us with their flooring projects.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {testimonials.map((testimonial, index) => (
              <div
                key={index}
                className="testimonial-card"
                data-testid={`testimonial-${index}`}
              >
                <div className="flex items-center gap-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 fill-amber-500 text-amber-500" />
                  ))}
                </div>
                <p className="text-stone-700 text-lg leading-relaxed mb-6 italic">
                  "{testimonial.text}"
                </p>
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center">
                    <span className="font-semibold text-amber-700">
                      {testimonial.name.split(' ').map(n => n[0]).join('')}
                    </span>
                  </div>
                  <div>
                    <p className="font-semibold text-amber-950">{testimonial.name}</p>
                    <p className="text-sm text-stone-500">{testimonial.location}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Service Area Section */}
      <section className="py-20 lg:py-28 section-stone noise-texture" data-testid="service-area-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <span className="inline-block px-4 py-2 bg-amber-100 text-amber-700 rounded-full text-sm font-medium mb-4">
                Service Areas
              </span>
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-amber-950 font-serif mb-6">
                Serving Los Angeles & Surrounding Areas
              </h2>
              <p className="text-lg text-stone-600 mb-8 leading-relaxed">
                Buy Fusion provides professional flooring installation services throughout Los Angeles County and neighboring communities. Our team travels to your location for convenient, on-site service.
              </p>
              <div className="grid grid-cols-2 gap-4 mb-8">
                {['Los Angeles', 'Santa Monica', 'Beverly Hills', 'Pasadena', 'Glendale', 'Burbank', 'Long Beach', 'Torrance'].map((city, index) => (
                  <div key={index} className="flex items-center gap-2">
                    <MapPin className="w-5 h-5 text-amber-600" />
                    <span className="text-stone-700">{city}</span>
                  </div>
                ))}
              </div>
              <Link to="/service-areas">
                <Button
                  variant="outline"
                  className="rounded-full px-8 py-6 text-lg font-medium border-2 border-stone-300 hover:border-amber-950 hover:bg-amber-950 hover:text-white transition-all"
                  data-testid="view-all-areas-btn"
                >
                  View All Service Areas
                  <ArrowRight className="ml-2 w-5 h-5" />
                </Button>
              </Link>
            </div>
            <div className="relative">
              <div className="bg-white rounded-2xl p-8 shadow-xl">
                <div className="flex items-center gap-4 mb-6">
                  <div className="w-14 h-14 bg-green-100 rounded-2xl flex items-center justify-center">
                    <MapPin className="w-7 h-7 text-green-700" />
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-amber-950 font-serif">Our Location</h3>
                    <p className="text-stone-600">Visit our showroom</p>
                  </div>
                </div>
                <address className="not-italic text-stone-600 mb-6">
                  88 Sunset Boulevard<br />
                  Los Angeles, CA 800134
                </address>
                <div className="bg-stone-100 rounded-xl h-48 flex items-center justify-center">
                  <span className="text-stone-400">Map Area</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-20 lg:py-28 section-white" data-testid="contact-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12">
            {/* Contact Info */}
            <div>
              <span className="inline-block px-4 py-2 bg-amber-100 text-amber-700 rounded-full text-sm font-medium mb-4">
                Get In Touch
              </span>
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-amber-950 font-serif mb-6">
                Ready to Transform Your Floors?
              </h2>
              <p className="text-lg text-stone-600 mb-8 leading-relaxed">
                Contact us today for a free, no-obligation estimate. Our team is ready to help you choose the perfect flooring solution for your home or business.
              </p>

              <div className="space-y-6 mb-8">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center flex-shrink-0">
                    <Phone className="w-6 h-6 text-green-700" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-amber-950 mb-1">Phone</h4>
                    <a href="tel:+18888791244" className="text-amber-600 hover:text-amber-700 font-medium">
                      +1-888-879-1244
                    </a>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-amber-100 rounded-xl flex items-center justify-center flex-shrink-0">
                    <svg className="w-6 h-6 text-amber-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                      <polyline points="22,6 12,13 2,6" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-semibold text-amber-950 mb-1">Email</h4>
                    <a href="mailto:support@buyfusion.store" className="text-amber-600 hover:text-amber-700">
                      support@buyfusion.store
                    </a>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-stone-100 rounded-xl flex items-center justify-center flex-shrink-0">
                    <MapPin className="w-6 h-6 text-stone-600" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-amber-950 mb-1">Address</h4>
                    <p className="text-stone-600">88 Sunset Boulevard, Los Angeles, CA 800134</p>
                  </div>
                </div>
              </div>

              <a href="tel:+18888791244" className="md:hidden">
                <Button
                  className="w-full bg-green-700 hover:bg-green-800 text-white rounded-full py-6 text-lg font-semibold"
                  data-testid="contact-call-btn"
                >
                  <Phone className="mr-2 w-5 h-5" />
                  Call Now: +1-888-879-1244
                </Button>
              </a>
            </div>

            {/* Contact Form */}
            <div className="bg-white rounded-2xl p-8 shadow-xl border border-stone-100">
              <h3 className="text-2xl font-semibold text-amber-950 font-serif mb-6">Request Free Estimate</h3>
              <form onSubmit={handleSubmit} className="space-y-5">
                <div>
                  <label className="block text-sm font-medium text-stone-700 mb-2">Name *</label>
                  <Input
                    type="text"
                    placeholder="Your full name"
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    className="form-input"
                    data-testid="contact-name-input"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-stone-700 mb-2">Phone Number *</label>
                  <Input
                    type="tel"
                    placeholder="(555) 123-4567"
                    value={formData.phone}
                    onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                    className="form-input"
                    data-testid="contact-phone-input"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-stone-700 mb-2">Email *</label>
                  <Input
                    type="email"
                    placeholder="your@email.com"
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    className="form-input"
                    data-testid="contact-email-input"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-stone-700 mb-2">Type of Flooring Service *</label>
                  <Select
                    value={formData.service_type}
                    onValueChange={(value) => setFormData({ ...formData, service_type: value })}
                  >
                    <SelectTrigger className="form-input" data-testid="contact-service-select">
                      <SelectValue placeholder="Select a service" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="hardwood">Hardwood Flooring</SelectItem>
                      <SelectItem value="vinyl">Vinyl Flooring</SelectItem>
                      <SelectItem value="laminate">Laminate Flooring</SelectItem>
                      <SelectItem value="tile">Tile Flooring</SelectItem>
                      <SelectItem value="carpet">Carpet Installation</SelectItem>
                      <SelectItem value="repair">Floor Repair</SelectItem>
                      <SelectItem value="other">Other</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-stone-700 mb-2">Message</label>
                  <Textarea
                    placeholder="Tell us about your project..."
                    value={formData.message}
                    onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                    className="form-input min-h-[120px] py-3"
                    data-testid="contact-message-input"
                  />
                </div>
                <div className="flex items-start gap-3">
                  <Checkbox
                    id="consent"
                    checked={formData.consent}
                    onCheckedChange={(checked) => setFormData({ ...formData, consent: checked })}
                    data-testid="contact-consent-checkbox"
                  />
                  <label htmlFor="consent" className="text-sm text-stone-600">
                    I agree to receive messages and communications from Buy Fusion regarding my inquiry.
                  </label>
                </div>
                <Button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full bg-green-700 hover:bg-green-800 text-white rounded-full py-6 text-lg font-semibold"
                  data-testid="contact-submit-btn"
                >
                  {isSubmitting ? 'Submitting...' : 'Get Free Estimate'}
                </Button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Mobile Sticky CTA */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 p-4 bg-white/90 backdrop-blur-sm border-t border-stone-200 z-40">
        <a href="tel:+18888791244">
          <Button
            className="w-full bg-green-700 hover:bg-green-800 text-white rounded-full py-4 text-base font-semibold"
            data-testid="mobile-sticky-call-btn"
          >
            <Phone className="mr-2 w-5 h-5" />
            Call Now: +1-888-879-1244
          </Button>
        </a>
      </div>
    </main>
  );
};

export default HomePage;
